export var getPlacement = function getPlacement(p) {
  var _jointPlacements$p;
  var jointPlacements = {
    'right-top': 'right-start',
    'right-bottom': 'right-end',
    'left-top': 'left-start',
    'left-bottom': 'left-end',
    'bottom-left': 'bottom-start',
    'bottom-right': 'bottom-end',
    'top-left': 'top-start',
    'top-right': 'top-end'
  };
  return (_jointPlacements$p = jointPlacements[p]) !== null && _jointPlacements$p !== void 0 ? _jointPlacements$p : p;
};
//# sourceMappingURL=placement.js.map